export default "__VITE_ASSET__Crem$Jwz__"